export const appName = 'Applio Spaces' as const;
export const initalNodeTree = [
	{ name: 'overview', link: '/', icon: 'nav-portfolio', isRoot: true, id: null },
	{ name: 'buildings', link: '/dashboard', icon: 'nav-building', isRoot: true, id: null },
	// { name: 'insights', link: '/insights', icon: 'nav-insights', isRoot: true, id: null },
	{
		name: 'account settings',
		link: '/account',
		icon: 'top-bar-settings',
		isRoot: true,
		id: null,
	},
] as const;

export const DATA_MAP: Record<number, string> = {
	0: 'Unknow',
	1: 'People',
	2: 'People lunch',
	3: 'People time (hours)',
	4: 'Office utilization (%)',
	5: 'Utilization time (minutes)',
	6: 'Room utilization (%)',
	7: 'Avg. temperature (°C)',
	8: 'Avg. humidity (%)',
	9: 'Avg. light (lux)',
	10: 'Utilization per person (hours)',
	11: 'Conference utilization (%)',
	12: 'Meetings per day',
	13: 'Avg. CO2 (ppm)',
	14: 'Sound avg (dB)',
	15: 'Sound peak (dB)',
	16: 'Motion',
	17: 'Activity',
	18: 'Min. CO2 (ppm)',
	19: 'Max. CO2 (ppm)',
	20: 'Min. sound avg (dB)',
	21: 'Max. sound avg (dB)',
	22: 'Min. sound peak (dB)',
	23: 'Max. sound peak (dB)',
	24: 'Min. motion',
	25: 'Max. motion',
	27: 'Min. Temperature',
	28: 'Min. Humidity',
	29: 'Max. Humidity',
	35: 'Max. people',
};
